const theme = {
  color: {
    background: "#252525",
    head: {
      caption: "#FFFFFF",
      name: "#FFFFFF",
      description: "#FFFFFF",
      buttonBackground: "#2188FF",
      buttonText: "#FFFFFF",
      buttonHover:
        "2px -2px 0px #6D93BE, -2px 2px 0px #6D93BE, 2px 2px 0px #6D93BE, -2px -2px 0px #6D93BE",
      toggleBackground: "#2188FF",
    },
    skillset: {
      header: "#FFFFFF",
      separator: "#E5E5E5",
      item: "#FFFFFF",
      background: "rgba(54, 54, 54, 0.72)",
    },
    projects: {
      mainHeader: "#FFFFFF",
      background: "rgba(54, 54, 54, 0.72)",
      header: "#FFFFFF",
      description: "#FFFFFF",
      info: "#FFFFFF",
      ref: "#2188FF",
      refHover: "#0366D6",
      tileBorderHover: "6px solid rgba(3, 102, 214, 0.5)",
    },
    contact: {
      header: "#FFFFFF",
      description: "#FFFFFF",
      email: "#FFFFFF",
      emailHover: "#2188FF",
    },
    loader: {
      header: "#FFFFFF",
    },
  },
  breakpoint: {
    mobile: "767px",
    iPad: "1024px",
  },
};
const lightTheme = {
  color: {
    background: "#E5E5E5",
    head: {
      caption: "#6E7E91",
      name: "#252525",
      description: "#6E7E91",
      buttonBackground: "#0366D6",
      buttonText: "#FFFFFF",
      buttonHover:
        "2px -2px 0px #8CC2FF, -2px 2px 0px #8CC2FF, 2px 2px 0px #8CC2FF, -2px -2px 0px #8CC2FF",
      toggleBackground: "#6E7E91",
    },
    skillset: {
      header: "#252525",
      separator: "rgba(209, 213, 218, 0.3)",
      item: "#6E7E91",
      background: "#FFFFFF",
    },
    projects: {
      mainHeader: "#252525",
      background: "#FFFFFF",
      header: "#0366D6",
      description: "#6E7E91",
      info: "#6E7E91",
      ref: "#0366D6",
      refHover: "#2188FF",
      tileBorderHover: "6px solid rgba(3, 102, 214, 0.2)",
    },
    contact: {
      header: "#6E7E91",
      description: "#252525",
      email: "#252525",
      emailHover: "#0366D6",
    },
    loader: {
      header: "#252525",
    },
  },
  breakpoint: {
    mobile: "767px",
    iPad: "1024px",
  },
};
export { theme, lightTheme };
